<template>
  <notifications position="top right" class="mr-4 mb-2 shadow">
    <template v-slot:body="{ item, close }" class="mb-2">
      <div :class="`rounded-lg ${item.type}-border-left shadow bg-white`">
        <div class="custom-notification1 p-2 d-flex flex-row align-items-center justify-content-between">
          <div class="d-flex flex-column align-items-start">
<!--            <h6>{{ item.title }}</h6>-->
            <h6><strong>Notification</strong></h6>
            <div v-html="item.text"></div>
          </div>
          <a class="close cursor-pointer" @click="close">
            <i class="fa fa-fw fa-close"></i>
          </a>
        </div>
      </div>
    </template>
  </notifications>
</template>

<script>
export default {
  // You can add props or methods here if needed
}
</script>

<style scoped>

.success-border-left {
  border-left: 5px solid #42a85f;
  background-color: #68cd86; /* Light green background */
}

.danger-border-left {
  border-left: 5px solid #b82e24;
  background-color: #e54d42; /* Light red background */
}

.custom-notification {
  padding: 10px;
  border-radius: 5px;
  margin: 10px 10px;
  position: relative;
  display: flex;
  align-items: center;
}

/* Add styles for light and dark themes */
.custom-notification-bg-color {
  background-color: rgba(255, 255, 255, 0.9); /* Light background */
  color: #333; /* Dark text for light theme */
}

.dark-theme .custom-notification-bg-color {
  background-color: rgba(30, 30, 30, 0.9); /* Dark background */
  color: #fff; /* Light text for dark theme */
}

/* Add shadow for better visibility */
.shadow {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.73);
}
</style>